import { Heading, Icon } from '@msaf/core-react'
import { ReactNode, useEffect } from 'react'

export interface MapContextContentProps {
  heading?: string
  headingIcon?: ReactNode
  headingAction?: ReactNode
  panelContent?: ReactNode
  scrollToTopOnContentChange?: boolean
}

export interface MapContextPanelContentProps extends MapContextContentProps {
  closePanel: () => void
}

export function MapContextPanelContent({
  heading,
  headingIcon,
  headingAction,
  closePanel,
  panelContent,
  scrollToTopOnContentChange = true,
}: MapContextPanelContentProps) {
  useEffect(() => {
    if (scrollToTopOnContentChange) {
      document.querySelector('.c-map-context-panel__content')?.scrollTo(0, 0)
    }
  }, [panelContent, scrollToTopOnContentChange])
  return (
    <>
      <div className='c-map-context-panel__header'>
        <div className='c-map-context-panel__heading-content'>
          {headingIcon && <div className='c-map-context-panel__heading-icon'>{headingIcon}</div>}
          <div className='c-map-context-panel__header-actions'>
            {headingAction}
            <button className='c-map-context-panel__close-btn' onClick={() => closePanel()}>
              <Icon icon='close' ariaLabel='Close menu panel' />
            </button>
          </div>
        </div>
        <div className='c-map-context-panel__heading-content'>
          <Heading level={2} className='c-map-context-panel__heading'>
            {heading}
          </Heading>
        </div>
      </div>
      <div className='c-map-context-panel__content'>{panelContent}</div>
    </>
  )
}
